import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next'

import { useLazyQuery } from '@apollo/client';
import { GET_COUNTRY_LIST } from 'graphql/common/queries';

export function NationalityDropdown({ fields }) {
  const { t } = useTranslation()

  const [nationalityList, setNationalityList] = useState(null)

  const [getCountryList, { loading: nationalityListLoading, error: nationalityListError }] = useLazyQuery(GET_COUNTRY_LIST, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onCompleted: data => {
      if (data.country.length > 0) {
        setNationalityList(data.country)
      }
      NationalityDropdown.propTypes = {
        fields: PropTypes.object.isRequired,
      };
    }
  },
  );


  // get Type List
  const getNationality = () => {
    getCountryList({
      variables: {
        "code": null
      },
    })
  }
  useEffect(() => {
    getNationality();
  }, []);

  return (
    <>
      {nationalityListLoading && <div className="flex justify-center items-center bg-white py-5">Loading ....</div>}
      {nationalityListError && (
        <select>
          <option value={null}>{t('No data found')}</option>
        </select>
      )}
      {!nationalityListLoading && !nationalityListError && nationalityList?.length === 0 && (
        <select>
          <option value={null}>{t('No data found')}</option>
        </select>
      )}
      {!nationalityListLoading && !nationalityListError && nationalityList?.length > 0 && (
        <select
          {...fields}
          disabled={fields.disabled}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:max-w-xs sm:text-sm sm:leading-6"
        >
          <option value="" label="Select a nationality" />
          {/* {purpose === 'filter' ? <option value={null}> {t('All')} </option> : <option value="" disabled> {t('Select Nationality')} </option>} */}
          {nationalityList.map((nationality) => (
            <option key={nationality.alpha_iso2} value={nationality.alpha_iso2}>
              {nationality.country}
            </option>
          ))}
        </select>
      )}
    </>
  );
}

